import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import PricingSection from "../../../subscreens/customer/pricingSection/PricingSection";
import CTASection from "../../../subscreens/customer/ctaSection/CTASection";
import PricingFAQSection from "../../../subscreens/customer/pricingFAQSection/PricingFAQSection";
import PricingHeroSection from "../../../subscreens/customer/pricingHeroSection/PricingHeroSection";
import MyLayout from "../../../layouts/customer/MyLayout";

const Pricing = () => {
  const Navigate = useNavigate();
  const { storeSelectedDistributor } = useContext(AppContext);
  return (
    <MyLayout>
      {/* <h1>This is Pricing Page</h1>
      <Button onClick={() => {
        storeSelectedDistributor("Milk Man");
        Navigate("/about");
      }} >Select Distributor</Button> */}
      <PricingHeroSection/>
      <PricingSection/>
      <PricingFAQSection/>
      <CTASection/>
    </MyLayout>
  );
};

export default Pricing;
